import { render, staticRenderFns } from "./EdenPeriods.vue?vue&type=template&id=ddfd234e&scoped=true"
import script from "./EdenPeriods.vue?vue&type=script&lang=js"
export * from "./EdenPeriods.vue?vue&type=script&lang=js"
import style0 from "./EdenPeriods.vue?vue&type=style&index=0&id=ddfd234e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfd234e",
  null
  
)

export default component.exports